/**
 * gtd_service-invntory API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PVIPlanPerson } from './pVIPlanPerson';


export interface PVIGetPlanRequest { 
    bookingNumber?: string;
    personalInfo?: Array<PVIPlanPerson>;
    planType?: PVIGetPlanRequest.PlanTypeEnum;
}
export namespace PVIGetPlanRequest {
    export const PlanTypeEnum = {
        Premium: 'PREMIUM',
        Normal: 'NORMAL',
        Basic: 'BASIC'
    } as const;
    export type PlanTypeEnum = typeof PlanTypeEnum[keyof typeof PlanTypeEnum];
}


